import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    IAgentProfileForCompanyClient,
} from 'interfaceAdapter/gatewaySchemas/IAgentProfileForCompanyClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class AgentProfileForCompanyClient implements IAgentProfileForCompanyClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, agent_id } = input;
        const PATH = `${API_LOCATION_URL}/agent/profile/for_company/${agent_id}`;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        if (token) {
            headers['X-HTTP-AUTH-TOKEN-C'] = token;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
